"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createStreamAlert = require("./createStreamAlert");
Object.keys(_createStreamAlert).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createStreamAlert[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createStreamAlert[key];
    }
  });
});